<div class="position-relative" style="z-index: 99999;">
  <div class="position-fixed top-0 start-0 end-0 bottom-0 p-2 pt-5 m-auto d-flex align-items-center justify-content-auto h-100 flex-column pe-none">
    <div class="p-3 z-0 rounded-0 position-relative bg-white shadow-lg border width-auto  pe-auto" *ngFor="let toast of toastService.toasts; let i = index" [class.show]="toast.show" role="alert" aria-live="assertive" aria-atomic="true" [style]="
        'margin-bottom:' + (i === toastService.toasts.length - 1 ? '0' : '0.75rem')
      ">
      <!-- <div class="toast-header">
        <strong class="me-auto">{{ toast.title || "Notification" }}</strong>
        <small>{{ toast.time || "Now" }}</small>
        <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close" (click)="removeToast(i)"></button>
      </div> -->
      <div class="position-absolute btn pe-none h-100 w-100 top-0 start-0 opacity-20 rounded-0" [class]="'bg-'+toast.class" style="z-index: -1;"></div>
      <div class="toast-body z-1" style="z-index: 5;">
        <div class="d-flex align-items-center">
          <span class="me-3 text-shadow text-nowrap" [class]="'text-'+toast.class || 'text-primary'">{{ toast.message | translate | async }}</span>
          <button type="button" class="btn outline-none border-0 ms-auto " [class]="'btn-outline-'+toast.class" data-bs-dismiss="toast" aria-label="Close" (click)="removeToast(i)"><i class="fa fa-close"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="position-relative" style="z-index: 99999;">
  <div class="position-fixed top-0 end-0 p-3">
    <div
      class="toast fade show"
      *ngFor="let toast of toastService.toasts; let i = index"
      [ngClass]="toast.class || 'btn-primary text-white'"
      [ngStyle]="{
        'margin-bottom': (i === toastService.toasts.length - 1 ? '0' : '1rem'),
        'box-shadow': '0 4px 12px rgba(0, 0, 0, 0.2)',
        'border-radius': '8px'
      }"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      data-bs-delay="5000"
    >
      <div class="d-flex align-items-center">
        <div class="toast-body" style="font-size: 16px; font-weight: 500; padding-right: 2rem;">
          {{ toast.message }}
        </div>
        <button
          type="button"
          class="btn-close ms-3 me-2"
          style="opacity: 0.8;"
          (click)="removeToast(i)"
        ></button>
      </div>
    </div>
  </div>
</div> -->